import { useTranslation } from "react-i18next";
import { Button } from "components/common/Button";
import { useFormContext } from "./formContext";
import type { HeaderActionsProps } from "./types";

export const HeaderActions = ({
  onSave,
  onCancel,
  onDelete,
}: HeaderActionsProps) => {
  const { t } = useTranslation();
  const form = useFormContext();

  return (
    <form.Subscribe selector={(s) => s.isDirty}>
      {(isDirty) => (
        <div className="flex items-center justify-end gap-2 w-full">
          {!isDirty && onDelete && (
            <Button variant="danger" onClick={onDelete}>
              {t("smartSurveyor.elementDetails.actions.delete")}
            </Button>
          )}
          {isDirty && (
            <>
              <Button className="flex-1" onClick={onCancel}>
                {t("smartSurveyor.elementDetails.actions.cancel")}
              </Button>
              <Button variant="primary" className="flex-1" onClick={onSave}>
                {t("smartSurveyor.elementDetails.actions.save")}
              </Button>
            </>
          )}
        </div>
      )}
    </form.Subscribe>
  );
};
